var _path, _path2, _path3, _path4, _path5, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNavigationBlack(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 168,
    height: 115,
    viewBox: "0 0 168 115",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M164.5 8.92314C164.5 14.8719 156.25 21.5642 156.25 21.5642C156.25 21.5642 148 14.8719 148 8.92314C148 4.38724 151.675 0.743652 156.25 0.743652C160.825 0.743652 164.5 4.38724 164.5 8.92314Z",
    fill: "#211F1F"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M156.25 14.128C159.149 14.128 161.5 11.7976 161.5 8.9229C161.5 6.04819 159.149 3.71777 156.25 3.71777C153.351 3.71777 151 6.04819 151 8.9229C151 11.7976 153.351 14.128 156.25 14.128Z",
    fill: "#3B3B3B"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M156.25 11.1539C157.493 11.1539 158.5 10.1552 158.5 8.92315C158.5 7.69113 157.493 6.69238 156.25 6.69238C155.007 6.69238 154 7.69113 154 8.92315C154 10.1552 155.007 11.1539 156.25 11.1539Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M14 111V47.2167H111.055V64.275H156V22",
    stroke: "black",
    strokeDasharray: "2 2"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M25.1584 95.8975C25.1584 103.696 14.8663 112.469 14.8663 112.469C14.8663 112.469 4.57422 103.696 4.57422 95.8975C4.57422 89.9513 9.15887 85.1748 14.8663 85.1748C20.5737 85.1748 25.1584 89.9513 25.1584 95.8975Z",
    fill: "#211F1F"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2810_8202)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M17.9646 91.1455H16.7734C16.6418 91.1455 16.5352 91.2516 16.5352 91.3824V91.4104L18.2029 92.7371V91.3824C18.2029 91.2516 18.0962 91.1455 17.9646 91.1455Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.2695 94.2256C14.2695 93.8985 14.5362 93.6333 14.8651 93.6333C15.1941 93.6333 15.4607 93.8985 15.4607 94.2256C15.4607 94.5528 15.1941 94.8179 14.8651 94.8179C14.5362 94.8179 14.2695 94.5528 14.2695 94.2256Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19.0336 94.9181L19.406 95.2143C19.5602 95.3369 19.785 95.3121 19.9083 95.1588C20.0316 95.0055 20.0066 94.7819 19.8525 94.6592L15.9806 91.5788C15.3281 91.0597 14.4008 91.0597 13.7482 91.5788L9.87632 94.6592C9.7222 94.7819 9.69722 95.0055 9.82051 95.1588C9.9438 95.3121 10.1687 95.3369 10.3228 95.2143L10.6952 94.9181V99.7938H10.0996C9.9022 99.7938 9.7422 99.9529 9.7422 100.149C9.7422 100.345 9.9022 100.505 10.0996 100.505H19.6293C19.8266 100.505 19.9866 100.345 19.9866 100.149C19.9866 99.9529 19.8266 99.7938 19.6293 99.7938H19.0336V94.9181ZM13.5541 94.226C13.5541 93.5063 14.1407 92.9229 14.8644 92.9229C15.5881 92.9229 16.1747 93.5063 16.1747 94.226C16.1747 94.9457 15.5881 95.5291 14.8644 95.5291C14.1407 95.5291 13.5541 94.9457 13.5541 94.226ZM14.8879 96.0029C15.2048 96.0029 15.4777 96.0029 15.6963 96.0321C15.9305 96.0635 16.1551 96.1341 16.3372 96.3152C16.5194 96.4964 16.5904 96.7197 16.6219 96.9526C16.6494 97.1564 16.6511 97.4077 16.6512 97.6979C16.6512 97.7173 16.6512 97.7368 16.6512 97.7565V99.7938H15.9365V97.7799C15.9365 97.4348 15.9357 97.2117 15.9135 97.0473C15.8927 96.8932 15.8591 96.8449 15.8319 96.8178C15.8046 96.7908 15.756 96.7573 15.601 96.7366C15.4358 96.7145 15.2114 96.7137 14.8644 96.7137C14.5174 96.7137 14.293 96.7145 14.1278 96.7366C13.9728 96.7573 13.9242 96.7908 13.897 96.8178C13.8698 96.8449 13.8361 96.8932 13.8153 97.0473C13.7931 97.2117 13.7923 97.4348 13.7923 97.7799V99.7938H13.0776V97.7565C13.0776 97.4415 13.0776 97.17 13.1069 96.9526C13.1384 96.7197 13.2095 96.4964 13.3916 96.3152C13.5737 96.1341 13.7983 96.0635 14.0326 96.0321C14.2511 96.0029 14.5241 96.0029 14.8409 96.0029H14.8879Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.2695 94.2256C14.2695 93.8985 14.5362 93.6333 14.8651 93.6333C15.1941 93.6333 15.4607 93.8985 15.4607 94.2256C15.4607 94.5528 15.1941 94.8179 14.8651 94.8179C14.5362 94.8179 14.2695 94.5528 14.2695 94.2256Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2810_8202"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 11.4356,
    height: 11.3725,
    fill: "white",
    transform: "translate(9.14844 89.7241)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNavigationBlack);
export default __webpack_public_path__ + "static/media/navigation-black.a8c1322289ae5fef9948ba9d91cedac2.svg";
export { ForwardRef as ReactComponent };